import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, {
    modelValue: _ctx.text,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.text) = $event)),
    dense: true,
    outlined: true,
    autofocus: true,
    label: _ctx.$t('widgetEnterText'),
    "bg-color": "white",
    color: "primary",
    onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.inputValue()), ["enter"]))
  }, _createSlots({ _: 2 }, [
    (_ctx.text)
      ? {
          name: "append",
          fn: _withCtx(() => [
            _createVNode(_component_q_btn, {
              icon: "send",
              flat: true,
              dense: true,
              round: true,
              color: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.inputValue()))
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "label"]))
}